import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast, ViewerContext } from 'dash-ui';
import {
  PaymentIntentStatusesEnum,
  PAYMENT_INTENT_ACTION_REQUIRED_STATUSES,
} from 'dash-common';
import { useStripe } from '@stripe/react-stripe-js';

export const usePaymentConfirmation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (productSubscription: any) => void;
  onError?: (error: string) => void;
} = {}): [(payload: any) => void, { stripeLoading: boolean }] => {
  const stripe = useStripe();
  const { setSubscription } = useContext(ViewerContext);
  const [stripeLoading, setStripeLoading] = useState(false);
  const { t } = useTranslation('pages', { keyPrefix: 'profilePage.billing' });

  const paymentConfirmation = ({
    productSubscription,
    productSubscriptionPayment,
  }: any = {}) => {
    if (productSubscription) {
      setSubscription && setSubscription(productSubscription);

      const { SUCCEEDED } = PaymentIntentStatusesEnum;
      const { clientSecret, paymentStatus } = productSubscriptionPayment || {};

      if (
        stripe &&
        clientSecret &&
        PAYMENT_INTENT_ACTION_REQUIRED_STATUSES.includes(
          paymentStatus as PaymentIntentStatusesEnum
        )
      ) {
        setStripeLoading(true);

        return stripe
          .confirmCardPayment(clientSecret)
          .then(({ paymentIntent, error }) => {
            setStripeLoading(false);

            if (error) {
              throw new Error(
                error?.message || error?.code || error.toString()
              );
            }

            if (paymentIntent?.status === SUCCEEDED.toLowerCase()) {
              return onSuccess && onSuccess(productSubscription);
            }

            throw new Error(t('unsuccessfulPayment') || '');
          })
          .catch((error) => {
            toast.error(error.toString());
            onError && onError(error.toString());
          });
      }

      if (!productSubscriptionPayment || paymentStatus === SUCCEEDED) {
        return onSuccess && onSuccess(productSubscription);
      }

      return onError && onError(t('unsuccessfulPayment') || '');
    }
  };

  return [paymentConfirmation, { stripeLoading }];
};
